import { getTenant, getUserName, orgSearch } from '../helpers';


export const getProgramDataAPI = async (programID, callback, programCoursesCallback)=> {
  try {
    const tenantToUse = new URLSearchParams(window.location.search).get('platform')
    const queryParam = new URLSearchParams({
      content: 'programs',
      program_id:programID,
      return_items:"True",
      tenant:tenantToUse ?? getTenant()
    });
    const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/personalized-catalog/${getUserName()}?${queryParam}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('dm_token'),
      },
    })
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to fetch program');
    }
    const data = await response.json();
    if(!(Array.isArray(data?.results) && data.results.length > 0)){
      throw new Error('Failed to fetch program');
    }
    //const result = Array.isArray(data?.results) && data.results.length > 0   ? data?.results[0] : null
    const programData = data?.results[0]
    callback(programData)
    const programCourses =  programData?.courses?.map((programCourse)=>(programCourse?.course)).filter((course)=>!!course)
    //const programCourses =  data?.results[0]?.data?.courses
    programCoursesCallback(programCourses)
  } catch (error) {
    callback(null)
    programCoursesCallback([])
  }
}

export const getEnrolledContents = (contentType="programs", callback)=>{
  const param = new URLSearchParams({
    //platform_key:getTenant(),
    username:getUserName(),
  }).toString()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/catalog/enrollment/${contentType}/?${param}`
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((response)=>{
    response.json().then(callback).catch(()=>callback([]))
  }).catch(()=>callback([]))
}

export const hasUserEnrolledProgram = (programID, callback=(data)=>{}, content='programs', contentKey='program_id')=>{
  const param = new URLSearchParams({
    platform_key:getTenant(),
    username:getUserName(),
    [contentKey]:programID
  }).toString()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/catalog/enrollment/${content}/?${param}`
   fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((response)=>{
    response.json().then((data)=>{
      callback(Array.isArray(data) && data.findIndex((pre)=>pre.active && pre?.[contentKey] === programID) !== -1)
    }).catch(()=>callback(false))
  }).catch((error)=>{
    callback(false)
  })
}

export const enrollUserInProgram = (programID, callback=(data)=>{}, content='programs/self', contentKey='program_id', includeUsername=true, extraParams={})=>{
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/catalog/enrollment/${content}/`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      [contentKey]:programID,
      ...(includeUsername && {username:getUserName()}),
      platform_key:getTenant(),
      active:true,
      ...extraParams
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((response)=>{
    callback(response.ok)
  }).catch((error)=>{
    callback(false)
  })
}